import { makeStyles } from 'tss-react/mui';


const useStyles = makeStyles()((theme) => ({
  paper: {
    padding: theme.spacing(6),
  },
}));

export default useStyles;